import {
  BannerFilterKeys,
  BannerListFilterOpts
} from "@saleor/banners/components/BannerListPage";
import { IFilterElement } from "@saleor/components/Filter";
import { findValueInEnum, joinDateTime, maybe } from "@saleor/misc";
import { BannerInput, SmopStatusEnum } from "@saleor/types/globalTypes";

import {
  createFilterTabUtils,
  createFilterUtils,
  dedupeFilter,
  getGteLteVariables,
  getMinMaxQueryParam,
  getSingleEnumValueQueryParam
} from "../../../utils/filters";
import {
  BannerListUrlFilters,
  BannerListUrlFiltersEnum,
  BannerListUrlFiltersWithMultipleValues,
  BannerListUrlQueryParams
} from "../../urls";

export const BANNER_FILTER_KEY = "bannerFilters";

export function getFilterOpts(
  params: BannerListUrlFilters
): BannerListFilterOpts {
  return {
    started: {
      active: maybe(
        () =>
          [params.startedFrom, params.startedTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.startedTo, ""),
        min: maybe(() => params.startedFrom, "")
      }
    },
    status: {
      active: maybe(() => params.status !== undefined, false),
      value: maybe(() => findValueInEnum(params.status, SmopStatusEnum))
    }
  };
}

export function getFilterVariables(params: BannerListUrlFilters): BannerInput {
  const startDate = "00:00";
  const endDate = "23:59";
  return {
    search: params.query,
    startDate: getGteLteVariables({
      gte: joinDateTime(params.startedFrom, startDate),
      lte: joinDateTime(params.startedTo, endDate)
    }),
    status:
      params.status !== undefined
        ? findValueInEnum(params.status, SmopStatusEnum)
        : null,

    verticals: params.verticals ? dedupeFilter(params.verticals) : []
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<BannerFilterKeys>
): BannerListUrlFilters {
  const { name } = filter;

  switch (name) {
    case BannerFilterKeys.started:
      return getMinMaxQueryParam(
        filter,
        BannerListUrlFiltersEnum.startedFrom,
        BannerListUrlFiltersEnum.startedTo
      );

    case BannerFilterKeys.status:
      return getSingleEnumValueQueryParam(
        filter,
        BannerListUrlFiltersEnum.status,
        SmopStatusEnum
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<BannerListUrlFilters>(BANNER_FILTER_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  BannerListUrlQueryParams,
  BannerListUrlFilters
>({
  ...BannerListUrlFiltersEnum,
  ...BannerListUrlFiltersWithMultipleValues
});
